import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditFlowTT } from 'features/cabinet/tiktok';
import { Guard, usePermissionGuard } from 'features/login';

const EditFlowPage: FC = () => {
  const { accessToChangeTiktokflow } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToChangeTiktokflow}>
      <CabinetTitlePage
        title={'Flows'}
        goBack={'/cabinet/tiktok/flows'}
      />
      <EditFlowTT />
    </Guard>
  );
};

export default EditFlowPage;
